// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-button[data-v-69889ee6]{color:#fff!important;font-weight:700!important}.custom-button[data-v-69889ee6],.custom-button[data-v-69889ee6]:hover{background-color:#c33d1b}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
